export default {
	SIGN: 'Sign',
	NEXT: 'Next',
	COUNTED_ITEMS: 'Counted Items',
	COUNT_REVIEW: 'Count Review'
};